import React from 'react';

import UserLayout from '../../shared/layouts/user-layout';
import DashboardComp from '../../components/dashboard-comp';
// style link end 

const Dashboard = () => {

    return (

        <UserLayout>
            <DashboardComp />
        </UserLayout>
    )
}

export default Dashboard;


